import type { ApiResponse, PagedResponseDto } from "@/types/common";
import type { BannerCreateDto, BannerDto, BannerFilterParams, BannerUpdateDto } from "@/types/banner.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const bannersService = {
  getAll(filter: BannerFilterParams = { activeOnly: true, pageSize: 20 }): Promise<PagedResponseDto<BannerDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<BannerDto>>>("/Banners", { params: filter }),
    );
  },

  getById(id: number): Promise<BannerDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<BannerDto>>(`/Banners/${id}`));
  },

  create(dto: BannerCreateDto): Promise<BannerDto> {
    return unwrapApiResponse(apiClient.post<ApiResponse<BannerDto>>("/Banners", dto));
  },

  update(id: number, dto: BannerUpdateDto): Promise<BannerDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<BannerDto>>(`/Banners/${id}`, dto));
  },

  delete(id: number): Promise<boolean> {
    return unwrapApiResponse(apiClient.delete<ApiResponse<boolean>>(`/Banners/${id}`));
  },
};
